import React, {Component} from 'react';
import {
  Badge,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  Dropdown
} from 'reactstrap';
import { connect } from 'react-redux';
import {Link, Redirect} from 'react-router-dom';

class HeaderDropdown extends Component {

  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      dropdownOpen: false
    };
  }

  toggle() {
    this.setState({
      dropdownOpen: !this.state.dropdownOpen
    });
  }

  dropAccnt() {
    return (
      <Dropdown isOpen={this.state.dropdownOpen} toggle={this.toggle} nav>
        <DropdownToggle nav>
          {this.props.user.firstname} {this.props.user.lastname}
        </DropdownToggle>
        <DropdownMenu right>
          <DropdownItem header tag="div" className="text-center"><strong>Settings</strong></DropdownItem>
          <Link to="/account/profile"><DropdownItem><i className="fa fa-user"></i>My Account</DropdownItem></Link>
          <Link to="/logout"><DropdownItem><i className="fa fa-lock"></i>Logout</DropdownItem></Link>
        </DropdownMenu>
      </Dropdown>
    );
  }

  render() {
    const {...attributes} = this.props;
    return (
      this.dropAccnt()
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user
});

export default connect(mapStateToProps)(HeaderDropdown);



// WEBPACK FOOTER //
// ./src/components/Header/HeaderDropdown.js